/**
 * Bootstrap Loader
 * 
 * This file loads Bootstrap and jQuery for the admin panel.
 * DO NOT put minified code here - import from node_modules instead.
 */

// Load jQuery (AdminLTE requires it)
try {
  window.$ = window.jQuery = require('jquery');
} catch (e) {
  console.error('jQuery not found:', e);
}

// Load Popper (required for Bootstrap dropdowns)
try {
  require('@popperjs/core');
} catch (e) {
  console.error('Popper not found:', e);
}

// Load Bootstrap and expose to window
try {
  const bootstrap = require('bootstrap');
  window.bootstrap = bootstrap;
} catch (e) {
  console.error('Bootstrap not found:', e);
}

// Load Axios for HTTP requests
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';